import React, { Component } from 'react';
import {
    Box,
    Typography,
    Card,
    CardActionArea,
    Avatar,
    Divider,
    CircularProgress,
} from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';
import { WithRouter } from '../../comp/WithRouter';
import { CartContext } from "../../comp/CartContext";
const STATUS_LABELS = {
    received: 'Aguardando aprovação',
    em_producao: 'Pedido em preparação',
    pronto: 'Pedido pronto',
    em_rota: 'Em Rota',
    entregues: 'Pedido concluído',
    canceled: 'Pedido Cancelado',
    cancelado: 'Pedido Cancelado',
};

class SeusPedidos extends Component {
    static contextType = CartContext;
    constructor(props) {
        super(props);
        this.state = {
            pedidos: [],
            loader: true,
        };
        this.lastProcessedUpdate = null;
    }

    componentDidMount() {
        fetch("/api/store/pedidos/", {
            method: "GET",
            credentials: "include",
            headers: {
                "Content-Type": "application/json",
            },
        })
            .then((response) => {
                if (response.status === 200) {
                    return response.json();
                }
                throw new Error("Erro ao carregar pedidos");
            })
            .then((data) => {
                this.setState({ pedidos: data, loader: false });
            })
            .catch((err) => {
                console.error("Erro no fetch:", err);
                this.setState({ loader: false });
            });
    }


    componentDidUpdate(prevProps, prevState) {
        // 1. Obtém o evento SSE transmitido via CartContext
        const lastOrderUpdate = this.context?.lastOrderUpdate;

        // 2. Valida se há um evento novo e evita processamento duplicado
        if (
            lastOrderUpdate &&
            lastOrderUpdate.id &&
            lastOrderUpdate !== this.lastProcessedUpdate
        ) {
            // Salva a referência para ignorar chamadas duplicadas
            this.lastProcessedUpdate = lastOrderUpdate;

            console.log("⚡ Atualizando item recebido via SSE:", lastOrderUpdate);

            const targetId = String(lastOrderUpdate.id);
            const novoStatus = lastOrderUpdate.status;
            const agora = new Date().toISOString();

            // 3. Imutabilidade: Atualiza APENAS o item correspondente dentro da lista
            this.setState((prevState) => ({
                pedidos: prevState.pedidos.map((pedido) => {
                    if (String(pedido.id) === targetId) {
                        return {
                            ...pedido,
                            status: novoStatus,
                            delivery_status: novoStatus,
                            ultimo_status_historico: novoStatus,
                            data_ultimo_status: agora,
                        };
                    }
                    return pedido; // Retorna os outros itens sem alteração
                }),
            }));
        }
    }


    formatCurrency = (value) => {
        return new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL',
        }).format(value || 0);
    };

    formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        return date.toLocaleDateString('pt-BR', {
            day: 'numeric',
            month: 'short',
            year: 'numeric',
        }).replace('.', '');
    };

    formatStatusDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        const now = new Date();

        const isToday =
            date.getDate() === now.getDate() &&
            date.getMonth() === now.getMonth() &&
            date.getFullYear() === now.getFullYear();

        const timeStr = date.toLocaleTimeString('pt-BR', {
            hour: '2-digit',
            minute: '2-digit',
        });

        if (isToday) {
            return `hoje, ${timeStr}`;
        }

        const dateStr = date.toLocaleDateString('pt-BR', {
            day: 'numeric',
            month: 'short',
        }).replace('.', '');

        return `${dateStr}, ${timeStr}`;
    };

    handleOpenPedido = (id) => {
        this.props.navigate(`/pedidos/${id}`);
    };

    render() {
        const { pedidos, loader } = this.state;

        if (loader) {
            return (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
                    <CircularProgress sx={{ color: '#2C3E50' }} />
                </Box>
            );
        }

        return (
            <Box
                sx={{
                    margin: '0 auto',
                    p: 1,
                    bgcolor: '#F4F6F8',
                    minHeight: '100vh',
                    fontFamily: 'Roboto, sans-serif',
                }}
            >
                <Typography
                    variant="h5"
                    sx={{
                        fontWeight: 800,
                        color: '#2C3E50',
                        mb: 3,
                        mt: 1,
                        fontSize: '1.5rem',
                    }}
                >
                    Seus pedidos
                </Typography>

                {pedidos.length === 0 ? (
                    <Typography variant="body1" sx={{ color: '#7F8C8D', textAlign: 'center', mt: 4 }}>
                        Nenhum pedido encontrado.
                    </Typography>
                ) : (
                    pedidos.map((pedido) => {
                        const isCancelado = pedido.status === 'canceled' || pedido.delivery_status === 'canceled' || pedido.ultimo_status_historico === 'cancelado';
                        const isConcluido = pedido.delivery_status === 'entregues' || pedido.ultimo_status_historico === 'entregues';
                        const isAtivo = !isCancelado && !isConcluido;

                        const tipoTexto = pedido.origem === 'pickup' ? 'Retirada' : 'Delivery';
                        const currentStatusKey = isCancelado ? 'canceled' : (pedido.ultimo_status_historico || pedido.delivery_status);
                        const statusTexto = STATUS_LABELS[currentStatusKey] || currentStatusKey;
                        const dataRodape = this.formatStatusDate(pedido.data_ultimo_status || pedido.data_venda);

                        return (
                            <Card
                                key={pedido.id}

                                sx={{
                                    mb: 2,
                                    borderRadius: '8px',
                                    boxShadow: '0px 2px 8px rgba(0,0,0,0.04)',
                                    border: '1px solid #EAECEE',
                                }}
                            >
                                <CardActionArea onClick={() => this.handleOpenPedido(pedido.id)}>
                                    <Box
                                        sx={{
                                            p: 2,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                        }}
                                    >
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                            <Avatar
                                                sx={{
                                                    width: 52,
                                                    height: 52,
                                                    bgcolor: isAtivo ? '#E8F5E9' : '#ECEFF1',
                                                    color: isAtivo ? '#66BB6A' : '#90A4AE',
                                                }}
                                            >
                                                {isAtivo ? (
                                                    <PlaylistAddCheckIcon fontSize="medium" />
                                                ) : (
                                                    <CheckCircleOutlineIcon fontSize="medium" />
                                                )}
                                            </Avatar>

                                            <Box>
                                                <Typography
                                                    variant="subtitle1"
                                                    sx={{
                                                        fontWeight: 800,
                                                        color: '#2C3E50',
                                                        lineHeight: 1.2,
                                                        fontSize: '1.05rem',
                                                    }}
                                                >
                                                    Pedido N° {pedido.id}
                                                </Typography>

                                                <Typography
                                                    variant="caption"
                                                    sx={{ color: '#95A5A6', display: 'block', my: 0.3 }}
                                                >
                                                    Feito em {this.formatDate(pedido.data_venda)}
                                                </Typography>

                                                <Typography
                                                    variant="body2"
                                                    sx={{ color: '#7F8C8D', fontSize: '0.85rem' }}
                                                >
                                                    Tipo:{' '}
                                                    <Box
                                                        component="span"
                                                        sx={{ fontWeight: 700, color: '#34495E', mr: 1 }}
                                                    >
                                                        {tipoTexto}
                                                    </Box>
                                                    Total:{' '}
                                                    <Box
                                                        component="span"
                                                        sx={{ fontWeight: 800, color: '#2C3E50' }}
                                                    >
                                                        {this.formatCurrency(pedido.total_venda)}
                                                    </Box>
                                                </Typography>
                                            </Box>
                                        </Box>

                                        <ChevronRightIcon
                                            sx={{
                                                color: isAtivo ? '#7CB342' : '#BDC3C7',
                                                fontSize: 28,
                                            }}
                                        />
                                    </Box>

                                    <Divider />

                                    <Box
                                        sx={{
                                            px: 2,
                                            py: 1.2,
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            bgcolor: '#FFF',
                                        }}
                                    >
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                            <Box
                                                sx={{
                                                    width: 10,
                                                    height: 10,
                                                    borderRadius: '50%',
                                                    bgcolor: isCancelado ? '#D32F2F' : (isAtivo ? '#7CB342' : '#90A4AE'),
                                                }}
                                            />
                                            <Typography
                                                variant="caption"
                                                sx={{
                                                    fontWeight: 500,
                                                    color: isCancelado ? '#D32F2F' : (isAtivo ? '#78909C' : '#95A5A6'),
                                                    fontSize: '0.82rem',
                                                }}
                                            >
                                                {statusTexto}
                                            </Typography>
                                        </Box>

                                        <Typography
                                            variant="caption"
                                            sx={{ color: '#95A5A6', fontSize: '0.8rem' }}
                                        >
                                            {dataRodape}
                                        </Typography>
                                    </Box>
                                </CardActionArea>
                            </Card>
                        );
                    })
                )}
            </Box>
        );
    }
}

export default WithRouter(SeusPedidos);